import React, { Component } from "react";
import classnames from "classnames";

import { Severity } from "@formant/core/model/Severity";

import { Chip } from "./Chip";
import * as styles from "./SeverityChip.scss";

export interface ISeverityChipProps {
    severity: Severity;
    className?: string;
}

export class SeverityChip extends Component<ISeverityChipProps> {
    public render() {
        const { severity } = this.props;
        return (
            <Chip
                className={classnames(
                    styles["severity-chip"],
                    styles[severity],
                )}
                data-tooltip={`Severity: ${severity}`}
            />
        );
    }
}
